import { render, staticRenderFns } from "./RequestReplyInputModal.vue?vue&type=template&id=384906bc&scoped=true&lang=pug"
import script from "./RequestReplyInputModal.vue?vue&type=script&lang=ts"
export * from "./RequestReplyInputModal.vue?vue&type=script&lang=ts"
import style0 from "./RequestReplyInputModal.vue?vue&type=style&index=0&id=384906bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384906bc",
  null
  
)

export default component.exports